import { render, staticRenderFns } from "./ClientResponsibleReportList.vue?vue&type=template&id=d508bd22&"
import script from "./ClientResponsibleReportList.vue?vue&type=script&lang=js&"
export * from "./ClientResponsibleReportList.vue?vue&type=script&lang=js&"
import style0 from "./ClientResponsibleReportList.vue?vue&type=style&index=0&id=d508bd22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports